import { SET_CUSTOMER_CUSTOMERS} from '../../actionTypes'

const initialState = []

export default (state=initialState,  action) => {
    switch(action.type) {
    case SET_CUSTOMER_CUSTOMERS:
        return action.customers || []
    default:
        return state
    }
}